import React from 'react';

import InlineSelectField from '../components/InlineSelectField';

const InlineReplenishmentStrategySelector = (props) => {

    const replenishmentStrategyOptions = [
        {id: 'SCHUHEDE', label: 'schuhe.de'},
        {id: 'IPOS', label: 'IPOS'}
    ];

    return (
        <InlineSelectField value={props.store ? props.store.replenishmentStrategy : ''}
                           options={replenishmentStrategyOptions}
                           onCommit={props.onCommit}/>
    );
};

export default InlineReplenishmentStrategySelector;



// WEBPACK FOOTER //
// ./src/admin/retailer/InlineReplenishmentStrategySelector.js